<div>
	<div class="modal-header">
		<button
			type="button"
			class="close"
			(click)="closeModal()"
			aria-label="Close">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>

	<form
		[formGroup]="form"
		(ngSubmit)="sendPush()"
		class="modal-body p-1 p-md-2 pb-3">
		<h2 class="text-center">Отправка уведомлений</h2>

		<div class="mx-1 mx-md-4 mt-2">
			<div>
				<div class="col-lg-12 mb-1 mb-lg-0">
					<div>
						<label for="add-user">Найти пользователя</label>
						<ng-select
							[items]="foundUsers"
							[clearable]="false"
							id="add-user"
							[closeOnSelect]="false"
							placeholder="Начните вводить пользователя"
							bindLabel="full_name"
							bindValue="id"
							[loading]="isLoadingUsers"
							formControlName="users"
							(input)="searchUsers($event)"
							notFoundText="Пользователи не найдены"
							[multiple]="true"
							(change)="onChangeUsers()"
							[searchFn]="customSearch"
							[clearSearchOnAdd]="true">
							<ng-template
								ng-option-tmp
								let-item="item">
								<div class="d-flex flex-column">
									<span class="font-weight-bold">{{ item?.full_name }}</span>
									<small class="text-secondary">{{ item?.email }}</small>
								</div>
							</ng-template>
						</ng-select>
					</div>
				</div>

				<div class="col-lg-12 my-1">
					<div class="custom-control custom-control-primary custom-checkbox">
						<input
							type="checkbox"
							class="custom-control-input"
							id="isSendToAll"
							[(ngModel)]="isSendToAll"
							[ngModelOptions]="{ standalone: true }"
							(ngModelChange)="onChangeSendToAll()" />
						<label
							class="custom-control-label"
							for="isSendToAll"
							>Отправить всем зарегистрированным пользователям</label
						>
					</div>
				</div>

				<div
					class="d-flex flex-column flex-lg-row col-lg-12 mb-1 mb-lg-0"
					formGroupName="title">
					<div class="form-group w-100 mr-1">
						<label for="title_ru">Заголовок (RU) *</label>
						<input
							id="title_ru"
							type="text"
							class="form-control"
							placeholder="Заголовок (RU)"
							formControlName="ru"
							[class.is-invalid]="
								form.get('title').get('ru').errors?.required && form.get('title').get('ru').touched
							" />

						<small
							class="text-danger font-weight-bolder"
							*ngIf="form.get('title').get('ru').errors?.required && form.get('title').get('ru').touched"
							>Поле обязательно</small
						>
					</div>

					<div class="form-group w-100">
						<label for="title_en">Заголовок (EN) *</label>
						<input
							id="title_en"
							type="text"
							class="form-control"
							placeholder="Заголовок (EN)"
							formControlName="en"
							[class.is-invalid]="
								form.get('title').get('en').errors?.required && form.get('title').get('en').touched
							" />

						<small
							class="text-danger font-weight-bolder"
							*ngIf="form.get('title').get('en').errors?.required && form.get('title').get('en').touched"
							>Поле обязательно</small
						>
					</div>
				</div>

				<div
					class="d-flex flex-column flex-lg-row col-lg-12 mb-1 mb-lg-0"
					formGroupName="body">
					<div class="form-group w-100 mr-1">
						<label for="body_ru">Описание (RU) *</label>
						<textarea
							id="body_ru"
							class="form-control textarea-noResize"
							rows="4"
							placeholder="Описание (RU)"
							formControlName="ru"
							[class.is-invalid]="
								form.get('body').get('ru').errors?.required && form.get('body').get('ru').touched
							"></textarea>

						<small
							class="text-danger font-weight-bolder"
							*ngIf="form.get('body').get('ru').errors?.required && form.get('body').get('ru').touched"
							>Поле обязательно</small
						>
					</div>

					<div class="form-group w-100">
						<label for="body_en">Описание (EN) *</label>
						<textarea
							id="body_en"
							class="form-control textarea-noResize"
							rows="4"
							placeholder="Описание (EN)"
							formControlName="en"
							[class.is-invalid]="
								form.get('body').get('ru').errors?.required && form.get('body').get('ru').touched
							"></textarea>

						<small
							class="text-danger font-weight-bolder"
							*ngIf="form.get('body').get('en').errors?.required && form.get('body').get('en').touched"
							>Поле обязательно</small
						>
					</div>
				</div>

				<div class="col-lg-12 mt-1">
					<div class="form-group">
						<label for="path">Диплинк *</label>
						<input
							type="text"
							class="form-control"
							id="path"
							placeholder="Введите диплинк"
							formControlName="path" />
					</div>
				</div>
			</div>

			<hr class="my-2" />

			<div class="d-flex flex-column flex-md-row">
				<button
					type="button"
					class="mb-1 mb-md-0 btn btn-outline-secondary w-100"
					rippleEffect
					(click)="closeModal()">
					Закрыть
				</button>
				<button
					type="submit"
					class="btn btn-primary w-100 ml-md-1 d-flex justify-content-center"
					rippleEffect
					[disabled]="form.invalid">
					<loader
						class="mr-1 btn-loader"
						*ngIf="isLoadingSendPush"></loader>
					<span>Отправить уведомление</span>
				</button>
			</div>
		</div>
	</form>
</div>
